<span class="notification-indicator"></span>
